import styles from './Avatar.module.css';

const AVATAR_COLORS = ['#abcebf', '#eccf8e', '#cedbf8', '#f8cece', '#d1f5e0', '#f8e1ce'];

const getInitials = (name) => name.split(' ').map((part) => part[0]).join('').toUpperCase();

const Avatar = ({ name, index = 0, size = 44 }) => {
    return (
        <div
            className={styles.avatar}
            style={{
                width: size,
                height: size,
                backgroundColor: AVATAR_COLORS[index % AVATAR_COLORS.length],
                fontSize: size / 2.75,
            }}
        >
            {getInitials(name)}
        </div>
    );
};

export default Avatar;
